import InputAdornment from "@mui/material/InputAdornment";
import { TextField } from "@mui/material";
import PropTypes from "prop-types";
import "./style.css";

const NumberField = ({
  placeholder,
  helperText,
  adornment,
  maxLength,
  onChange,
  disabled,
  onInput,
  onKeyUp,
  value,
  error,
  type,
  name,
  dir,
  id,
}) => {
  return (
    <TextField
      disabled={disabled}
      placeholder={placeholder}
      fullWidth
      InputProps={
        adornment
          ? {
              startAdornment: (
                <InputAdornment position="start">{adornment}</InputAdornment>
              ),
            }
          : undefined
      }
      onInput={onInput}
      onChange={onChange}
      value={value}
      size="small"
      id={id}
      name={name}
      type={type}
      inputProps={{ dir: dir, maxLength: maxLength }}
      onKeyUp={onKeyUp}
      error={error}
      helperText={helperText}
    />
  );
};

NumberField.propTypes = {
  placeholder: PropTypes.string,
  helperText: PropTypes.string,
  maxLength: PropTypes.number,
  adornment: PropTypes.any,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  onInput: PropTypes.func,
  onKeyUp: PropTypes.func,
  type: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.any,
  error: PropTypes.any,
  dir: PropTypes.any,
  id: PropTypes.any,
};

export default NumberField;
